/* eslint-disable camelcase */
import React, { Fragment } from "react";
import { union } from "@utils/lodash";
import { Summary, Table } from "@pages/reports/components";
import PaymentHistoryReport from "@pages/reports/PaymentHistoryReport";
import DetailedInvoiceReport from "@pages/reports/DetailedInvoiceReport";
import DepartmentInvoiceReport from "@pages/reports/DepartmentInvoiceReport";
import FairnessReport from "@pages/reports/FairnessReport";
import CallOffReport from "@pages/reports/CallOffReport";
import utils from "@utils";
import { JOBS_ALERTS_LEGEND } from "@constants";
import { Link } from "react-router";
import {
	paymentReportsColumn,
	reportsJobColumn,
	detailedJobReportsColumn,
	jurisdictionFeePaymentColumns,
	clientPaymentColumns,
	locationPaymentColumns,
	invoicePaymentColumns,
	fairnessColumns,
} from "./columnsDefinition";

export default {
	render_client_overview(params, user, getData = false) {
		const { lang } = global;
		const summaryLeftList = [
			{
				key: lang.t("Client First Start Date"),
				value: utils.formatDate(
					`${params.ClientFirstStartDate}Z`,
					"en-US",
					user.timeZoneId,
				),
			},
			{
				key: lang.t("Primary Client Supervisor"),
				value: params.PrimaryClientSupervisor,
			},
			{
				key: `# ${lang.t("Active Projects")}`,
				value: params.ActiveProjectsCount ? params.ActiveProjectsCount : "N/A",
			},
			{
				key: `# ${lang.t("Inactive Projects")}`,
				value: params.InActiveProjectsCount ? params.InActiveProjectsCount : "N/A",
			},
		];

		let summaryRightListValue = [];

		if (
			params.LocationJobOverviewList &&
			params.LocationJobOverviewList.constructor === Array &&
			params.LocationJobOverviewList.length > 0
		) {
			summaryRightListValue = [
				{
					type: "location",
					coordinates: {
						lat: params.LocationJobOverviewList[0].Latitude,
						lng: params.LocationJobOverviewList[0].Longitude,
					},
					address: params.LocationJobOverviewList[0].JobLocationAddress,
				},
			];
		}

		const summaryRightList = summaryRightListValue;

		const reportOverviewColumns = [
			{
				property: "empty",
				name: "",
			},
			{
				property: "projects",
				name: lang.t("Projects"),
			},
			{
				property: "job_count",
				name: lang.t("Total Jobs"),
			},
			{
				property: "total_hours",
				name: lang.t("Total Hours"),
			},
			{
				property: "locations_count",
				name: lang.t("Locations"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
		];
		const reportOverviewData = [
			{
				empty: lang.t("Scheduled"),
				projects: params.ScheduledProjectsCount ? params.ScheduledProjectsCount : "N/A",
				job_count: params.ScheduledJobCount ? params.ScheduledJobCount : "N/A",
				total_hours: params.TotalScheduledHours ? params.TotalScheduledHours : "N/A",
				locations_count: params.TotalLocationScheduledCount
					? params.TotalLocationScheduledCount
					: "N/A",
				officers_assigned_count: params.TotalOfficersScheduledCount
					? params.TotalOfficersScheduledCount
					: "N/A",
			},
			{
				empty: lang.t("Worked"),
				projects: params.WorkedProjectsCount ? params.WorkedProjectsCount : "N/A",
				job_count: params.WorkedJobCount ? params.WorkedJobCount : "N/A",
				total_hours: params.TotalWorkedHours ? params.TotalWorkedHours : "N/A",
				locations_count: params.TotalLocationWorkedCount
					? params.TotalLocationWorkedCount
					: "N/A",
				officers_assigned_count: params.TotalOfficersWorkedCount
					? params.TotalOfficersWorkedCount
					: "N/A",
			},
		];

		const projectsColumns = [
			{
				property: "project",
				name: "",
			},
			{
				property: "client_supervisor",
				name: lang.t("Client Supervisor"),
			},
			{
				property: "job_count",
				name: lang.t("Total Jobs"),
			},
			{
				property: "total_hours_scheduled",
				name: lang.t("Total Hours Scheduled"),
			},
			{
				property: "total_hours_worked",
				name: lang.t("Total Hours Worked"),
			},
			{
				property: "locations_count",
				name: lang.t("Locations"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
			{
				property: "officers_worked_count",
				name: `# ${lang.t("Officers Worked")}`,
			},
			{
				property: "status",
				name: lang.t("Status"),
			},
		];

		const jobsColumns = [
			{
				property: "job_id",
				name: lang.t("Job ID"),
				urlBase: "/jobs/%value%",
			},
			{
				property: "date",
				name: lang.t("Date"),
			},
			{
				property: "start_time",
				name: lang.t("Start Time"),
			},
			{
				property: "project_title",
				name: lang.t("Project Name"),
			},
			{
				property: "job_title",
				name: lang.t("Job Name"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "rank",
				name: "Officer Rank",
			},
			{
				property: "officer",
				name: lang.t("Officer"),
			},
			{
				property: "clock_in",
				name: lang.t("Clock In"),
			},
			{
				property: "clock_out",
				name: lang.t("Clock Out"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
			{
				property: "alerts",
				name: lang.t("Alerts"),
				title: "%value%",
			},
		];

		const locationsColumns = [
			{
				property: "project",
				name: lang.t("Project"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "location_address",
				name: lang.t("Address"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
		];

		const officersColumns = [
			{
				property: "officer",
				name: lang.t("Officer Name"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
		];

		if (getData) {
			let data = [];
			const summary = this.getReportSummary(
				params.ClientName,
				summaryLeftList,
				summaryRightList,
				true,
			);
			const reportOverview = this.getReportOverviewTable(
				reportOverviewColumns,
				reportOverviewData,
				true,
			);
			const projectOverview = this.getProjectsOverviewTable(
				params.ProjectJobOverviewList,
				projectsColumns,
				true,
			);
			const jobsOverview = this.getJobsOverviewTable(
				params.JobOverviewList,
				jobsColumns,
				user.TimeZoneId,
				user,
				true,
			);
			const locationsOverview = this.getLocationsOverviewTable(
				params.LocationJobOverviewList,
				locationsColumns,
				true,
			);
			const officersOverview = this.getOfficersOverviewTable(
				params.OfficerJobOverviewList,
				officersColumns,
				true,
			);
			const maxColumns = Math.max(
				summaryLeftList.length + summaryRightList.length,
				reportOverviewColumns.length,
				projectsColumns.length,
				jobsColumns.length,
				locationsColumns.length,
				officersColumns.length,
			);
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			data = [
				firstRow,
				{ "": "Report Summary" },
				...summary,
				{},
				{ "": "Report Overview" },
				...reportOverview,
				{},
				{ "": "Project Overview" },
				...projectOverview,
				{},
				{ "": "Jobs Overview" },
				...jobsOverview,
				{},
				{ "": "Locations Overview" },
				...locationsOverview,
				{},
				{ "": "Officers Overview" },
				...officersOverview,
			];
			return data;
		}
		return (
			<div
				className="panel reports-panel"
				key="report_client_overview"
			>
				{this.getReportSummary(params.ClientName, summaryLeftList, summaryRightList)}
				<div className="panel-content">
					{this.getReportOverviewTable(reportOverviewColumns, reportOverviewData)}
					{this.getProjectsOverviewTable(params.ProjectJobOverviewList, projectsColumns)}
					{this.getJobsOverviewTable(
						params.JobOverviewList,
						jobsColumns,
						user.TimeZoneId,
						user,
					)}
					{this.renderJobAlertsLegend()}
					{this.getLocationsOverviewTable(
						params.LocationJobOverviewList,
						locationsColumns,
					)}
					{this.getOfficersOverviewTable(params.OfficerJobOverviewList, officersColumns)}
				</div>
			</div>
		);
	},

	render_project_overview(params, user, locationMode = false, getData = false) {
		const { lang } = global;

		const summaryLeftList = [
			{
				key: lang.t("Client Name"),
				value: params.ClientName,
			},
			{
				key: lang.t("Primary Agency Supervisor"),
				value: params.PrimarySupervisor,
			},
			{
				key: lang.t("Project Start Date"),
				value: utils.formatDate(
					`${params.ProjectFirstStartDate}Z`,
					"en-US",
					user.timeZoneId,
				),
			},
		];

		let summaryRightListValue = [];

		if (
			params.LocationJobOverviewList &&
			params.LocationJobOverviewList.constructor === Array &&
			params.LocationJobOverviewList.length > 0
		) {
			summaryRightListValue = [
				{
					type: "location",
					coordinates: {
						lat: params.LocationJobOverviewList[0].Latitude,
						lng: params.LocationJobOverviewList[0].Longitude,
					},
					address: params.LocationJobOverviewList[0].JobLocationAddress,
				},
			];
		}

		const summaryRightList = summaryRightListValue;

		const reportOverviewColumns = [
			{
				property: "empty",
				name: "",
			},
			{
				property: "job_count",
				name: lang.t("Total Jobs"),
			},
			{
				property: "total_hours",
				name: lang.t("Total Hours"),
			},
			{
				property: "locations_count",
				name: lang.t("Locations"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
		];
		const reportOverviewData = [
			{
				empty: lang.t("Scheduled"),
				job_count: params.ScheduledJobCount ? params.ScheduledJobCount : "N/A",
				total_hours: params.TotalScheduledHours ? params.TotalScheduledHours : "N/A",
				locations_count: params.TotalLocationScheduledCount
					? params.TotalLocationScheduledCount
					: "N/A",
				officers_assigned_count: params.TotalOfficersScheduledCount
					? params.TotalOfficersScheduledCount
					: "N/A",
			},
			{
				empty: lang.t("Worked"),
				job_count: params.WorkedJobCount ? params.WorkedJobCount : "N/A",
				total_hours: params.TotalWorkedHours ? params.TotalWorkedHours : "N/A",
				locations_count: params.TotalLocationWorkedCount
					? params.TotalLocationWorkedCount
					: "N/A",
				officers_assigned_count: params.TotalOfficersWorkedCount
					? params.TotalOfficersWorkedCount
					: "N/A",
			},
		];

		const jobsColumns = [
			{
				property: "job_id",
				name: lang.t("Job ID"),
				urlBase: "/jobs/%value%",
			},
			{
				property: "date",
				name: lang.t("Date"),
			},
			{
				property: "start_time",
				name: lang.t("Start Time"),
			},
			{
				property: "project_title",
				name: lang.t("Project Name"),
			},
			{
				property: "job_title",
				name: lang.t("Job Name"),
			},
			{
				property: "position",
				name: lang.t("Position"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "rank",
				name: "Officer Rank",
			},
			{
				property: "officer",
				name: lang.t("Officer"),
			},
			{
				property: "clock_in",
				name: lang.t("Clock In"),
			},
			{
				property: "clock_out",
				name: lang.t("Clock Out"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
			{
				property: "alerts",
				name: lang.t("Alerts"),
				title: "%value%",
			},
		];

		const locationsColumns = [
			{
				property: "project",
				name: lang.t("Project"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "location_address",
				name: lang.t("Address"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
		];

		const officersColumns = [
			{
				property: "officer",
				name: lang.t("Officer Name"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
		];

		if (getData) {
			let data = [];
			const summary = this.getReportSummary(
				params.ClientName,
				summaryLeftList,
				summaryRightList,
				true,
			);
			const reportOverview = this.getReportOverviewTable(
				reportOverviewColumns,
				reportOverviewData,
				true,
			);
			const jobsOverview = this.getJobsOverviewTable(
				params.JobOverviewList,
				jobsColumns,
				user.TimeZoneId,
				user,
				true,
			);
			const locationsOverview = this.getLocationsOverviewTable(
				params.LocationJobOverviewList,
				locationsColumns,
				true,
			);
			const officersOverview = this.getOfficersOverviewTable(
				params.OfficerJobOverviewList,
				officersColumns,
				true,
			);
			const maxColumns = Math.max(
				summaryLeftList.length + summaryRightList.length,
				reportOverviewColumns.length,
				jobsColumns.length,
				locationsColumns.length,
				officersColumns.length,
			);
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			data = [
				firstRow,
				{ "": "Report Summary" },
				...summary,
				{},
				{ "": "Report Overview" },
				...reportOverview,
				{},
				{ "": "Jobs Overview" },
				...jobsOverview,
				{},
				{ "": "Locations Overview" },
				...locationsOverview,
				{},
				{ "": "Officers Overview" },
				...officersOverview,
			];
			return data;
		}

		return (
			<div
				className="panel reports-panel"
				key="report_project_overview"
			>
				{this.getReportSummary(
					!locationMode ? params.ProjectName : params.LocationName,
					summaryLeftList,
					summaryRightList,
				)}
				<div className="panel-content">
					{this.getReportOverviewTable(reportOverviewColumns, reportOverviewData)}
					{this.getJobsOverviewTable(
						params.JobOverviewList,
						jobsColumns,
						user.TimeZoneId,
						user,
					)}
					{this.renderJobAlertsLegend()}
					{this.getLocationsOverviewTable(
						params.LocationJobOverviewList,
						locationsColumns,
					)}
					{this.getOfficersOverviewTable(params.OfficerJobOverviewList, officersColumns)}
				</div>
			</div>
		);
	},

	render_location_overview(params, user, getData = false) {
		return this.render_project_overview(params, user, true, getData);
	},

	render_agency_overview(params, user, detailed = false, coordinator = false, getData = false) {
		const { lang } = global;
		const summaryLeftList = [
			{
				key: `${coordinator ? lang.t("Coordinator") : lang.t("Agency")} ${lang.t("First Start Date")}`,
				value: utils.formatDate(
					`${params.AgencyFirstStartDate}Z`,
					"en-US",
					user.timeZoneId,
				),
			},
			{
				key: lang.t("Active Clients Count"),
				value: params.ActiveClientCount,
			},
			{
				key: lang.t("Inactive Clients Count"),
				value: params.InActiveClientCount,
			},
		];

		const summaryRightList = params.LocationJobOverviewList.length
			? [
					{
						type: "location",
						coordinates: {
							lat: params.LocationJobOverviewList[0].Latitude,
							lng: params.LocationJobOverviewList[0].Longitude,
						},
						address: params.LocationJobOverviewList[0].JobLocationAddress,
					},
				]
			: [];
		let reportOverviewColumns = [
			{
				property: "empty",
				name: "",
			},
			{
				property: "clients",
				name: lang.t("Clients"),
			},
			{
				property: "projects",
				name: lang.t("Projects"),
			},
			{
				property: "total_job_count",
				name: lang.t("Total Jobs"),
			},
			{
				property: "total_hours",
				name: lang.t("Total Hours"),
			},
			{
				property: "locations",
				name: lang.t("Locations"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
		];
		const reportOverviewData = [
			{
				empty: lang.t("Scheduled"),
				clients: params.ScheduledClientsCount ? params.ScheduledClientsCount : "N/A",
				projects: params.ScheduledProjectsCount ? params.ScheduledProjectsCount : "N/A",
				total_job_count: params.ScheduledJobCount ? params.ScheduledJobCount : "N/A",
				total_hours: params.TotalScheduledHours ? params.TotalScheduledHours : "N/A",
				locations: params.TotalLocationScheduledCount
					? params.TotalLocationScheduledCount
					: "N/A",
				officers_assigned_count: params.TotalOfficersScheduledCount
					? params.TotalOfficersScheduledCount
					: "N/A",
			},
			{
				empty: lang.t("Worked"),
				clients: params.WorkedClientsCount ? params.WorkedClientsCount : "N/A",
				projects: params.WorkedProjectsCount ? params.WorkedProjectsCount : "N/A",
				total_job_count: params.WorkedJobCount ? params.WorkedJobCount : "N/A",
				total_hours: params.TotalWorkedHours ? params.TotalWorkedHours : "N/A",
				locations: params.TotalLocationWorkedCount
					? params.TotalLocationWorkedCount
					: "N/A",
				officers_assigned_count: params.TotalOfficersWorkedCount
					? params.TotalOfficersWorkedCount
					: "N/A",
			},
		];

		const jobsColumnsA = [
			{
				property: "job_id",
				name: lang.t("Job ID"),
				urlBase: "/jobs/%value%",
			},
			{
				property: "date",
				name: lang.t("Date"),
			},
			{
				property: "start_time",
				name: lang.t("Start Time"),
			},
			{
				property: "client",
				name: lang.t("Client"),
			},
			{
				property: "project_title",
				name: lang.t("Project Name"),
			},
			{
				property: "job_title",
				name: lang.t("Job Name"),
			},
			{
				property: "job_tags",
				name: lang.t("Tags"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "rank",
				name: "Officer Rank",
			},
			{
				property: "officer",
				name: lang.t("Officer"),
			},
		];

		if (user.Organization.UseZones) {
			jobsColumnsA.push({
				property: "job_zone",
				name: lang.t("Zone"),
			});
		}

		const jobsColumnsB = [
			{
				property: "rate",
				name: lang.t("Rate"),
			},
			{
				property: "clock_in",
				name: lang.t("Clock In"),
			},
			{
				property: "clock_out",
				name: lang.t("Clock Out"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
			{
				property: "est_officer_pay",
				name: lang.t("Estimated Officer Pay"),
			},
			{
				property: "vehicle",
				name: lang.t("Vehicle"),
			},
			{
				property: "alerts",
				name: lang.t("Alerts"),
				title: "%value%",
			},
		];

		const jobsColumnsDetails = [
			{
				property: "email",
				name: lang.t("EMail"),
			},
			{
				property: "mobile",
				name: lang.t("Mobile"),
			},
		];

		const jobsColumns = union(jobsColumnsA, detailed ? jobsColumnsDetails : [], jobsColumnsB);

		let locationsColumns = [
			{
				property: "client",
				name: lang.t("Client"),
			},
			{
				property: "project",
				name: lang.t("Project"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "location_address",
				name: lang.t("Address"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
		];

		if (user.Organization.UseZones) {
			locationsColumns.push({
				property: "zone",
				name: lang.t("Zone"),
			});
		}

		const officersColumns = [
			{
				property: "officer",
				name: lang.t("Officer Name"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
		];

		const clientsColumns = [
			{
				property: "client",
				name: "",
			},
			{
				property: "total_projects_count",
				name: lang.t("Total Project Count"),
			},
			{
				property: "job_count",
				name: lang.t("Total Jobs"),
			},
			{
				property: "total_hours_scheduled",
				name: lang.t("Total Hours Scheduled"),
			},
			{
				property: "total_hours_worked",
				name: lang.t("Total Hours Worked"),
			},
			{
				property: "locations_count",
				name: lang.t("Locations"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
			{
				property: "officers_worked_count",
				name: `# ${lang.t("Officers Worked")}`,
			},
		];

		const projectsColumns = [
			{
				property: "project",
				name: "",
			},
			{
				property: "client",
				name: lang.t("Client"),
			},
			{
				property: "job_count",
				name: lang.t("Total Jobs"),
			},
			{
				property: "total_hours_scheduled",
				name: lang.t("Total Hours Scheduled"),
			},
			{
				property: "total_hours_worked",
				name: lang.t("Total Hours Worked"),
			},
			{
				property: "locations_count",
				name: lang.t("Locations"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
			{
				property: "officers_worked_count",
				name: `# ${lang.t("Officers Worked")}`,
			},
			{
				property: "status",
				name: lang.t("Status"),
			},
		];

		if (coordinator) {
			reportOverviewColumns = reportOverviewColumns.filter(
				({ property }) => property !== "projects",
			);
			locationsColumns = locationsColumns.filter(({ property }) => property !== "projects");
		}

		if (getData) {
			let data = [];
			const summary = this.getReportSummary(
				params.ClientName,
				summaryLeftList,
				summaryRightList,
				true,
			);
			const reportOverview = this.getReportOverviewTable(
				reportOverviewColumns,
				reportOverviewData,
				true,
			);
			const clientOverview = this.getClientsOverviewTable(
				params.ClientJobOverviewList,
				clientsColumns,
				true,
			);
			const projectOverview = this.getProjectsOverviewTable(
				params.ProjectJobOverviewList,
				projectsColumns,
				true,
			);
			const jobsOverview = this.getJobsOverviewTable(
				params.JobOverviewList,
				jobsColumns,
				user.TimeZoneId,
				user,
				true,
			);
			const locationsOverview = this.getLocationsOverviewTable(
				params.LocationJobOverviewList,
				locationsColumns,
				true,
			);
			const officersOverview = this.getOfficersOverviewTable(
				params.OfficerJobOverviewList,
				officersColumns,
				true,
			);
			const maxColumns = Math.max(
				summaryLeftList.length + summaryRightList.length,
				reportOverviewColumns.length,
				projectsColumns.length,
				jobsColumns.length,
				locationsColumns.length,
				officersColumns.length,
			);
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			data = [
				firstRow,
				{ "": "Report Summary" },
				...summary,
				{},
				{ "": "Report Overview" },
				...reportOverview,
				{},
				{ "": "Client Overview" },
				...clientOverview,
				{},
				{ "": "Project Overview" },
				...projectOverview,
				{},
				{ "": "Jobs Overview" },
				...jobsOverview,
				{},
				{ "": "Locations Overview" },
				...locationsOverview,
				{},
				{ "": "Officers Overview" },
				...officersOverview,
			];
			return data;
		}

		return (
			<div
				className="panel reports-panel"
				key="report_agency_overview"
			>
				{this.getReportSummary(params.AgencyName, summaryLeftList, summaryRightList)}
				<div className="panel-content">
					{this.getReportOverviewTable(reportOverviewColumns, reportOverviewData)}
					{this.getClientsOverviewTable(params.ClientJobOverviewList, clientsColumns)}
					<If condition={!coordinator}>
						{this.getProjectsOverviewTable(
							params.ProjectJobOverviewList,
							projectsColumns,
						)}
					</If>
					{this.getJobsOverviewTable(
						params.JobOverviewList,
						jobsColumns,
						user.TimeZoneId,
						user,
					)}
					{this.renderJobAlertsLegend()}
					{this.getLocationsOverviewTable(
						params.LocationJobOverviewList,
						locationsColumns,
					)}
					{this.getOfficersOverviewTable(
						params.OfficerJobOverviewList,
						!detailed ? officersColumns : undefined,
					)}
				</div>
			</div>
		);
	},

	render_agency_overview_detailed(params, user, getData = false) {
		return this.render_agency_overview(params, user, true, false, getData);
	},

	render_coordinator_overview(params, user, getData = false) {
		return this.render_agency_overview(params, user, true, true, getData);
	},

	render_officer_overview(params, user, getData = false) {
		const { lang } = global;
		const summaryLeftList = [
			{
				type: "subtitle",
				value: lang.t("Contact Details"),
			},
			{
				key: "Phone",
				value: params.Phone ? utils.formatPhoneNumber(params.Phone) : "N/A",
			},
			{
				key: "Email",
				value: params.Email,
			},
			{
				type: "subtitle",
				value: lang.t("Emergency Contact"),
			},
			{
				key: "Name",
				value: params.ContactName || "N/A",
			},
			{
				key: "Phone",
				value: params.ContactPhone ? utils.formatPhoneNumber(params.ContactPhone) : "N/A",
			},
			{
				type: "subtitle",
				value: lang.t("Service Details"),
			},
			{
				key: "Jurisdiction",
				value: params.Jurisdiction || "N/A",
			},
			{
				key: "Rank",
				value: params.Rank || "N/A",
			},
			{
				key: "Police Officer Number",
				value: params.PoliceOfficerNumber ? params.PoliceOfficerNumber : "N/A",
			},
			{
				key: "Supervisor",
				value: params.Supervisor ? params.Supervisor : "N/A",
			},
			{
				key: "Supervisor Phone",
				value: params.SupervisorPhone ? utils.formatPhoneNumber(params.SupervisorPhone) : "N/A",
			},
			{
				key: "Supervisor Email",
				value: params?.SupervisorEmail ?? "N/A",
			},
		];
		const summaryRightList = [
			{
				type: "picture",
				url: params.ContactPhotoUrl,
			},
			{
				type: "subtitle",
				value: "RollKall Statistics",
			},
			{
				key: "Total Agencies",
				value: params.TotalAgencies,
			},
			{
				key: "Total Clients",
				value: params.TotalClients,
			},
			{
				key: "Total Jobs Scheduled",
				value: params.TotalJobsScheduled,
			},
			{
				key: "Total Jobs Worked",
				value: params.TotalJobsWorked,
			},
			{
				key: lang.t("Total Hours Scheduled"),
				value: params.TotalHoursScheduled,
			},
			{
				key: lang.t("Total Hours Worked"),
				value: params.TotalHoursWorked,
			},
			{
				type: "subtitle",
				value: "RollKall Alerts",
			},
			{
				key: "Total Late Clock-Ins",
				value: params.TotalLateClockIns,
			},
			{
				key: "Total Early Clock-Outs",
				value: params.TotalEarlyClockOuts,
			},
			{
				key: "Total Job Offsite",
				value: params.TotalJobsOffsite,
			},
		];

		const reportOverviewColumns = [
			{
				property: "empty",
				name: "",
			},
			{
				property: "total_jobs_assigned",
				name: "Total Jobs Assigned",
			},
			{
				property: "total_hours",
				name: lang.t("Total Hours"),
			},
			{
				property: "locations",
				name: lang.t("Locations"),
			},
			{
				property: "late_clock_ins",
				name: "# Late Clock-Ins",
			},
			{
				property: "early_clock_outs",
				name: "# Early Clock-Outs",
			},
			{
				property: "offsite_notifications",
				name: "# Off-Site Notifications",
			},
		];
		const reportOverviewData = [
			{
				empty: lang.t("Scheduled"),
				total_jobs_assigned: params.TotalJobsScheduled,
				total_hours: params.TotalHoursScheduled,
				locations: params.TotalLocationScheduledCount,
				late_clock_ins: "",
				early_clock_outs: "",
				offsite_notifications: "",
			},
			{
				empty: lang.t("Worked"),
				total_jobs_assigned: params.TotalJobsWorked,
				total_hours: params.TotalHoursWorked,
				locations: params.TotalLocationWorkedCount,
				late_clock_ins: params.TotalLateClockIns,
				early_clock_outs: params.TotalEarlyClockOuts,
				offsite_notifications: params.TotalJobsOffsite,
			},
		];

		const jobsColumns = [
			{
				property: "job_id",
				name: lang.t("Job ID"),
				urlBase: "/jobs/%value%",
			},
			{
				property: "date",
				name: lang.t("Date"),
			},
			{
				property: "start_time",
				name: lang.t("Start Time"),
			},
			{
				property: "client",
				name: lang.t("Client"),
			},
			{
				property: "project_title",
				name: lang.t("Project Name"),
			},
			{
				property: "job_title",
				name: lang.t("Job Name"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "clock_in",
				name: lang.t("Clock In"),
			},
			{
				property: "clock_out",
				name: lang.t("Clock Out"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
			{
				property: "alerts",
				name: lang.t("Alerts"),
				title: "%value%",
			},
		];

		const locationsColumns = [
			{
				property: "client",
				name: lang.t("Client"),
			},
			{
				property: "project",
				name: lang.t("Project"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "location_address",
				name: lang.t("Address"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
		];

		if (getData) {
			let data = [];
			const summary = this.getReportSummary(
				params.ClientName,
				summaryLeftList,
				summaryRightList,
				true,
			);
			const reportOverview = this.getReportOverviewTable(
				reportOverviewColumns,
				reportOverviewData,
				true,
			);
			const jobsOverview = this.getJobsOverviewTable(
				params.JobOverviewList,
				jobsColumns,
				user.TimeZoneId,
				user,
				true,
			);
			const locationsOverview = this.getLocationsOverviewTable(
				params.LocationJobOverviewList,
				locationsColumns,
				true,
			);
			const maxColumns = Math.max(
				summaryLeftList.length + summaryRightList.length,
				reportOverviewColumns.length,
				jobsColumns.length,
				locationsColumns.length,
			);
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			data = [
				firstRow,
				{ "": "Report Summary" },
				...summary,
				{},
				{ "": "Report Overview" },
				...reportOverview,
				{},
				{ "": "Jobs Overview" },
				...jobsOverview,
				{},
				{ "": "Locations Overview" },
				...locationsOverview,
			];
			return data;
		}

		return (
			<div
				className="panel reports-panel"
				key="report_officer_overview"
			>
				{this.getReportSummary(params.Name, summaryLeftList, summaryRightList)}
				<div className="panel-content">
					{this.getReportOverviewTable(reportOverviewColumns, reportOverviewData)}
					{this.getJobsOverviewTable(
						params.JobOverviewList,
						jobsColumns,
						user.TimeZoneId,
						user,
					)}
					{this.renderJobAlertsLegend()}
					{this.getLocationsOverviewTable(
						params.LocationJobOverviewList,
						locationsColumns,
					)}
				</div>
			</div>
		);
	},

	render_jurisdiction_overview(params, user, getData = false) {
		const { lang } = global;

		const summaryLeftList = [
			{
				key: "Officers Count",
				value: params.OfficersCount ? params.OfficersCount : "N/A",
			},
			{
				key: "Active Officers Count",
				value: params.ActiveOfficersCount ? params.ActiveOfficersCount : "N/A",
			},
		];
		const summaryRightList =
			params.LocationJobOverviewList && params.LocationJobOverviewList.length !== 0
				? [
						{
							type: "location",
							coordinates: {
								lat: params.Latitude,
								lng: params.Longitude,
							},
							address: params.Address,
						},
					]
				: [];
		const reportOverviewColumns = [
			{
				property: "empty",
				name: "",
			},
			{
				property: "agencies",
				name: "Agencies",
			},
			{
				property: "clients",
				name: lang.t("Clients"),
			},
			{
				property: "locations",
				name: lang.t("Locations"),
			},
			{
				property: "jobs",
				name: lang.t("Jobs"),
			},
			{
				property: "total_hours",
				name: lang.t("Hours"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
		];
		const reportOverviewData = [
			{
				empty: lang.t("Scheduled"),
				agencies: params.ScheduledAgencyCount ? params.ScheduledAgencyCount : "N/A",
				clients: params.ScheduledClientsCount ? params.ScheduledClientsCount : "N/A",
				locations: params.TotalLocationScheduledCount
					? params.TotalLocationScheduledCount
					: "N/A",
				jobs: params.ScheduledJobCount ? params.ScheduledJobCount : "N/A",
				total_hours: params.TotalScheduledHours ? params.TotalScheduledHours : "N/A",
				officers_assigned_count: params.TotalOfficersScheduledCount
					? params.TotalOfficersScheduledCount
					: "N/A",
			},
			{
				empty: lang.t("Worked"),
				agencies: params.WorkedAgencyCount ? params.WorkedAgencyCount : "N/A",
				clients: params.WorkedClientsCount ? params.WorkedClientsCount : "N/A",
				locations: params.TotalLocationWorkedCount
					? params.TotalLocationWorkedCount
					: "N/A",
				jobs: params.WorkedJobCount ? params.WorkedJobCount : "N/A",
				total_hours: params.TotalWorkedHours ? params.TotalWorkedHours : "N/A",
				officers_assigned_count: params.TotalOfficersWorkedCount
					? params.TotalOfficersWorkedCount
					: "N/A",
			},
		];

		const officersColumns = [
			{
				property: "officer",
				name: lang.t("Officer Name"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
		];

		if (getData) {
			let data = [];
			const summary = this.getReportSummary(
				params.ClientName,
				summaryLeftList,
				summaryRightList,
				true,
			);
			const reportOverview = this.getReportOverviewTable(
				reportOverviewColumns,
				reportOverviewData,
				true,
			);
			const agencyOverview = this.getAgencyOverviewTable(
				params.AgencyJobOverviewList,
				undefined,
				true,
			);
			const clientOverview = this.getClientsOverviewTable(
				params.ClientJobOverviewList,
				undefined,
				true,
			);
			const jobsOverview = this.getJobsOverviewTable(
				params.JobOverviewList,
				undefined,
				user.TimeZoneId,
				user,
				true,
			);
			const locationsOverview = this.getLocationsOverviewTable(
				params.LocationJobOverviewList,
				undefined,
				true,
			);
			const officersOverview = this.getOfficersOverviewTable(
				params.OfficerJobOverviewList,
				officersColumns,
				true,
			);
			const maxColumns = Math.max(
				summaryLeftList.length + summaryRightList.length,
				reportOverviewColumns.length,
				Object.keys(jobsOverview[0]).length,
				officersColumns.length,
			);
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			data = [
				firstRow,
				{ "": "Report Summary" },
				...summary,
				{},
				{ "": "Report Overview" },
				...reportOverview,
				{},
				{ "": "Agency Overview" },
				...agencyOverview,
				{},
				{ "": "Client Overview" },
				...clientOverview,
				{},
				{ "": "Jobs Overview" },
				...jobsOverview,
				{},
				{ "": "Locations Overview" },
				...locationsOverview,
				{},
				{ "": "Officers Overview" },
				...officersOverview,
			];
			return data;
		}
		return (
			<div
				className="panel reports-panel"
				key="report_jurisdiction_overview"
			>
				{this.getReportSummary(params.JurisdictionName, summaryLeftList, summaryRightList)}
				<div className="panel-content">
					{this.getReportOverviewTable(reportOverviewColumns, reportOverviewData)}
					{this.getAgencyOverviewTable(params.AgencyJobOverviewList)}
					{this.getClientsOverviewTable(params.ClientJobOverviewList)}
					{this.getJobsOverviewTable(
						params.JobOverviewList,
						undefined,
						user.TimeZoneId,
						user,
					)}
					{this.renderJobAlertsLegend()}
					{this.getLocationsOverviewTable(params.LocationJobOverviewList)}
					{this.getOfficersOverviewTable(params.OfficerJobOverviewList, officersColumns)}
				</div>
			</div>
		);
	},

	render_payment_history(params, user, getData = false) {
		if (getData) {
			const client = this.getGenericPaymentsData(
				paymentReportsColumn("Client"),
				params.ClientPaymentSummaries,
			);
			const coordinator = this.getGenericPaymentsData(
				paymentReportsColumn("Coordinator"),
				params.SupervisorPaymentSummaries,
			);
			const locationCols = this.getGenericPaymentsData(
				paymentReportsColumn("Location"),
				params.LocationPaymentSummaries,
			);
			const jurisdictionCols = this.getGenericPaymentsData(
				paymentReportsColumn("Jurisdiction"),
				params.JurisdictionFeesPaymentSummaries,
			);
			const feeCols = this.getGenericPaymentsData(
				paymentReportsColumn("Fee"),
				params.FeeTypePaymentSummaries,
			);
			const officerCols = this.getGenericPaymentsData(
				paymentReportsColumn("Officer"),
				params.OfficerPaymentSummaries,
			);
			const paymentHistoryCols = this.getGenericPaymentsData(
				reportsJobColumn("paymentHistory", user.TimeZoneId, user),
				params.JobPaymentSummaries,
			);
			const maxColumns = Math.max(
				Object.keys(client[0]).length,
				Object.keys(coordinator[0]).length,
				Object.keys(locationCols[0]).length,
				Object.keys(jurisdictionCols[0]).length,
				Object.keys(feeCols[0]).length,
				Object.keys(officerCols[0]).length,
				Object.keys(paymentHistoryCols[0]).length,
			);
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			const data = [
				firstRow,
				{ "": "Total Paid", " ": "Total Fees Paid", "  ": "Total Officer Pay" },
				{
					"": params.TotalPaid,
					" ": params.TotalJurisdictionFees,
					"  ": params.TotalPaidToOfficers,
				},
				{},
				{ "": "Client" },
				...client,
				{},
				{ "": "Coordinator Fees" },
				...coordinator,
				{},
				{ "": "Locations" },
				...locationCols,
				{},
				{ "": "Jurisdiction Fees" },
				...jurisdictionCols,
				{},
				{ "": "Fee Type Payment Summary" },
				...feeCols,
				{},
				{ "": "Officers" },
				...officerCols,
				{},
				{ "": "Invoices" },
				...paymentHistoryCols,
			];
			return data;
		}
		return (
			<PaymentHistoryReport
				key="payment_history_report"
				data={params}
				user={user}
			/>
		);
	},

	render_invoice_report(params, user, getData = false) {
		if (getData) {
			const detailedInvoice = this.getGenericPaymentsData(
				detailedJobReportsColumn(user),
				params.JobDetailedPaymentSummaries,
			);
			const maxColumns = Math.max(Object.keys(detailedInvoice[0]).length);
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			const data = [firstRow, { "": "Invoice Report (Detailed)" }, ...detailedInvoice];
			return data;
		}
		return (
			<DetailedInvoiceReport
				key="detailed_invoice_report"
				data={params}
				user={user}
			/>
		);
	},

	render_invoice_aging(params) {
		// PBI-159: This report renders exactly the same as the existing aging report for manual invoices, no need to rewrite logic
		return this.render_manual_aging(params);
	},

	render_department_invoice_report(params, user, getData = false) {
		if (getData) {
			const jurisdictionFee = this.getGenericPaymentsData(
				jurisdictionFeePaymentColumns(),
				params.JurisdictionFeePaymentSummaries,
			);
			const client = this.getGenericPaymentsData(
				clientPaymentColumns(),
				params.ClientPaymentSummaries,
			);
			const locationCols = this.getGenericPaymentsData(
				locationPaymentColumns(),
				params.LocationPaymentSummaries,
			);
			const invoice = this.getGenericPaymentsData(
				invoicePaymentColumns(),
				params.InvoicePaymentSummaries,
			);
			const maxColumns = Math.max(
				Object.keys(client[0]).length,
				Object.keys(jurisdictionFee[0]).length,
				Object.keys(locationCols[0]).length,
				Object.keys(invoice[0]).length,
			);
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			const data = [
				firstRow,
				{
					"": "Total Invoiced",
					" ": "Total Paid",
					"  ": "Total Fees Invoiced",
					"   ": "Total Fees Paid",
				},
				{
					"": params.TotalInvoiced,
					" ": params.TotalPaid,
					"  ": params.TotalFeesInvoiced,
					"   ": params.TotalFeesPaid,
				},
				{},
				{ "": "Fee Type Invoice Summary" },
				...jurisdictionFee,
				{},
				{ "": "Client Payment Summary" },
				...client,
				{},
				{ "": "Location Payment Summary" },
				...locationCols,
				{},
				{ "": "Invoice Payment Summary" },
				...invoice,
			];
			return data;
		}
		return (
			<DepartmentInvoiceReport
				key="department_invoice_report"
				data={params}
				TimeZoneId={user.TimeZoneId}
				user={user}
			/>
		);
	},

	render_fairness(params, getData = false) {
		if (getData === true) {
			const reportData = [...params.OfficerList];
			reportData.push({
				Name: "Total",
				JobsScheduled: params.TotalJobsScheduled || 0,
				JobsApplied: params.TotalJobsApplied || 0,
				JobsScheduled30Day: params.TotalJobsScheduled30Day || 0,
				HoursScheduled30Day: params.TotalHoursScheduled30Day || 0,
				JobsScheduledPercentage: params.TotalJobsScheduledPercentage || 0,
				Id: -1,
			});
			const fairness = this.getGenericPaymentsData(fairnessColumns(), reportData);
			const maxColumns = Math.max(Object.keys(fairness[0]).length);
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			const data = [firstRow, { "": "Fairness Report" }, ...fairness];
			return data;
		}
		return (
			<FairnessReport
				key="fairness_report"
				data={params}
			/>
		);
	},

	render_calloff(params, user, getData = false) {
		if (getData === true) {
			const callOffsColumns = [
				{
					property: "JobEventId",
					name: "Job ID",
				},
				{
					property: "OfficerName",
					name: "Officer",
				},
				{
					property: "OfficerEmail",
					name: "Officer email",
				},
				{
					property: "ClientName",
					name: "Client",
				},
				{
					property: "JobStartDateTime",
					name: "Job Date",
				},
				{
					property: "Location",
					name: "Location",
				},
				{
					property: "CallOffDate",
					name: "Completed call-off date",
				},
				{
					property: "Voided",
					name: "Voided",
				},
				{
					property: "CallOffType",
					name: "Call off type",
				},
				{
					property: "Reason",
					name: "Reason",
				},
				{
					property: "Comments",
					name: "Comments",
				},
			];

			const items = params.Items.map(item => ({
				...item,
				JobStartDateTime: utils.formatDate(
					new Date(`${item.JobStartDateTime}Z`),
					"en-US",
					user.TimeZoneId,
				),
				CallOffDate: utils.formatDate(
					new Date(`${item.CallOffDate}Z`),
					"en-US",
					user.TimeZoneId,
				),
				Voided: item.Voided ? "Yes" : "No",
			}));

			const calloffs = this.getGenericData(callOffsColumns, items);
			const maxColumns = callOffsColumns.length;
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			const data = [firstRow, { "": "Officer Un-assignment Overview Report" }, ...calloffs];
			return data;
		}
		return (
			<CallOffReport
				key="calloff_report"
				rows={params}
				TimeZoneId={user.TimeZoneId}
			/>
		);
	},

	render_manual_invoice(params) {
		const columns = [
			{ property: "InvoiceNumber", name: "Invoice Number" },
			{ property: "EarliestJobStartTime", name: "From" },
			{ property: "LatestJobStartTime", name: "To" },
			{ property: "ClientName", name: "Client" },
			{ property: "OfficerPay", name: "Officer Pay", class: "text-right" },
			{ property: "AgencyFees", name: "Agency Fees", class: "text-right" },
			{ property: "VehicleFees", name: "Vehicle Fees", class: "text-right" },
			{ property: "EquipmentFees", name: "Equipment Fees", class: "text-right" },
			{ property: "OtherFees", name: "Miscellaneous Fees", class: "text-right" },
			{ property: "Total", name: "Total", class: "text-right" },
			{ property: "PaidAmount", name: "Paid", class: "text-right" },
			{ property: "Balance", name: "Balance", class: "text-right" },
		];

		const data = params.data.map(item => ({
			...item,
			EarliestJobStartTime: utils.formatDate(
				`${item.EarliestJobStartTime}Z`,
				"en-US",
				undefined,
				"numeric",
			),
			LatestJobStartTime: utils.formatDate(
				`${item.LatestJobStartTime}Z`,
				"en-US",
				undefined,
				"numeric",
			),
			ClientName: item.ClientName || "Unknown",
			OfficerPay: utils.currencyFormatter(item.OfficerPay),
			AgencyFees: utils.currencyFormatter(item.AgencyFees),
			VehicleFees: utils.currencyFormatter(item.VehicleFees),
			EquipmentFees: utils.currencyFormatter(item.EquipmentFees),
			OtherFees: utils.currencyFormatter(item.OtherFees),
			Total: utils.currencyFormatter(item.Total),
			PaidAmount: utils.currencyFormatter(item.PaidAmount),
			Balance: utils.currencyFormatter(item.Balance),
		}));

		return this.getGenericTable(columns, data);
	},

	render_payroll_report(params, user, getData = false) {
		const columns = [
			{ property: "PONumber", name: "Police Officer Id" },
			{ property: "JobEventId", name: "Job ID" },
			{ property: "StartDateTime", name: "Start Date Time" },
			{ property: "EndDateTime", name: "End Date Time" },
			{ property: "Hours", name: "Hours Worked" },
			{ property: "Name", name: "Short Code" },
			{ property: "Description", name: "Description" },
		];

		const data = params.data.map(item => ({
			...item,
			StartDateTime: utils.formatDate(
				new Date(`${item.StartDateTime}Z`),
				"en-US",
				user.TimeZoneId,
				user.UserPreferences === "useMilitaryTime" ? "dt-short-mil" : "dt-short",
			),
			EndDateTime: utils.formatDate(
				new Date(`${item.EndDateTime}Z`),
				"en-US",
				user.TimeZoneId,
				user.UserPreferences === "useMilitaryTime" ? "dt-short-mil" : "dt-short",
			),
		}));

		if (getData) {
			const payroll = this.getGenericData(columns, data);
			const maxColumns = columns.length;
			const firstRow = {};
			let auxStr = "";
			for (let i = 0; i < maxColumns; i++) {
				firstRow[auxStr] = "";
				auxStr += " ";
			}
			const auxData = [firstRow, { "": "Payroll Report" }, ...payroll];
			return auxData;
		}

		return this.getGenericTable(columns, data);
	},

	render_manual_aging(params) {
		const columns = [
			{ property: "ClientId", name: "Client ID" },
			{ property: "ClientName", name: "Client Name" },
			{ property: "Total", name: "Total", class: "text-right" },
			{ property: "Current", name: "Current", class: "text-right" },
			{ property: "OneToThirtyDays", name: "1-30 Days", class: "text-right" },
			{ property: "ThirtyOneToSixtyDays", name: "31-60 Days", class: "text-right" },
			{ property: "GreaterThanSixtyDays", name: "60+ Days", class: "text-right" },
		];

		const totals = {
			ClientId: (
				<strong>{`Totals (as of ${utils.formatDate(new Date(), "en-US", undefined)}):`}</strong>
			),
			ClientName: "",
			Total: 0,
			Current: 0,
			OneToThirtyDays: 0,
			ThirtyOneToSixtyDays: 0,
			GreaterThanSixtyDays: 0,
		};

		const data = params.data.map(item => {
			totals.Total += item.Total;
			totals.Current += item.Current;
			totals.OneToThirtyDays += item.OneToThirtyDays;
			totals.ThirtyOneToSixtyDays += item.ThirtyOneToSixtyDays;
			totals.GreaterThanSixtyDays += item.GreaterThanSixtyDays;

			return {
				...item,
				ClientName: item.ClientName || "Unknown",
				Total: utils.currencyFormatter(item.Total),
				Current: utils.currencyFormatter(item.Current),
				OneToThirtyDays: utils.currencyFormatter(item.OneToThirtyDays),
				ThirtyOneToSixtyDays: utils.currencyFormatter(item.ThirtyOneToSixtyDays),
				GreaterThanSixtyDays: utils.currencyFormatter(item.GreaterThanSixtyDays),
			};
		});

		totals.Total = <strong>{utils.currencyFormatter(totals.Total)}</strong>;
		totals.Current = <strong>{utils.currencyFormatter(totals.Current)}</strong>;
		totals.OneToThirtyDays = <strong>{utils.currencyFormatter(totals.OneToThirtyDays)}</strong>;
		totals.ThirtyOneToSixtyDays = (
			<strong>{utils.currencyFormatter(totals.ThirtyOneToSixtyDays)}</strong>
		);
		totals.GreaterThanSixtyDays = (
			<strong>{utils.currencyFormatter(totals.GreaterThanSixtyDays)}</strong>
		);

		data.push(totals);

		return this.getGenericTable(columns, data);
	},

	render_applied_payments(params, user) {
		const columns = [
			{ property: "ClientName", name: "Client Name" },
			{ property: "InvoiceNumber", name: "Invoice Number" },
			{ property: "PaymentAmount", name: "Amount", class: "text-right" },
			{ property: "PaymentUserFullName", name: "Paid By" },
			{ property: "PaidDate", name: "Paid On" },
			{ property: "PaymentComments", name: "Comments" },
		];

		const data = params.data.map(item => ({
			...item,
			ClientName: item.ClientName || "Unknown",
			PaymentAmount: utils.currencyFormatter(item.PaymentAmount),
			PaidDate: utils.formatDate(
				new Date(`${item.PaymentCreatedDateTimeUTC}Z`),
				"en-US",
				user.TimeZoneId,
				user.UserPreferences === "useMilitaryTime" ? "dt-num-mil" : "dt-num",
			),
		}));

		return this.getGenericTable(columns, data);
	},

	render_deposit(params, user) {
		const depositIds = [];
		const columns = [
			{ property: "InvoiceId", name: "Invoice Number" },
			{ property: "DepositedOnDate", name: "Deposited on" },
			{ property: "Total", name: "Deposit Total" },
			{ property: "ClientName", name: "Client Name" },
			{ property: "OfficerName", name: "Officer Name" },
			{ property: "OfficerPay", name: "Officer Pay" },
			{ property: "Rate", name: "Job Rate" },
			{ property: "Hours", name: "Invoiced Hours" },
			{ property: "LEAPay", name: "LEA Pay" },
			{ property: "AgencyFees", name: "Agency Fees" },
			{ property: "CoordinatorFees", name: "Coordinator Fees" },
			{ property: "EquipmentFees", name: "Equipment Fees" },
			{ property: "VehicleFees", name: "Vehicle Fees" },
			{ property: "OtherFees", name: "Additional Fees" },
			{ property: "DepositId", name: "Deposit Id" },
		];

		const data = params.data.map(item => {
			let invoiceIdContent = (
				<Link to={`/payments/manualinvoice?id=${item.InvoiceId}`}>
					{item.InvoiceNumber}
				</Link>
			);
			let hideInfo = false;

			if (item.IsRKPay) {
				invoiceIdContent = <Link to={`/payments/${item.InvoiceId}`}>{item.InvoiceId}</Link>;
			}

			if (item.DepositId !== null && item.DepositId !== undefined) {
				if (!depositIds.includes(item.DepositId)) {
					depositIds.push(item.DepositId);
				} else {
					hideInfo = true;
				}
			}

			return {
				...item,
				InvoiceId: !hideInfo ? invoiceIdContent : "",
				DepositId: !hideInfo ? item.DepositId : "",
				ClientName: !hideInfo ? item.ClientName : "",
				OtherFees: !hideInfo ? item.OtherFees : "",
				Total: !hideInfo ? item.Total : "",
				DepositedOnDate: !hideInfo
					? utils.formatDate(
							new Date(`${item.DepositedOnDate}Z`),
							"en-US",
							user.TimeZoneId,
							user.UserPreferences === "useMilitaryTime"
								? "dt-short-mil"
								: "dt-short",
						)
					: "",
			};
		});

		return this.getGenericTable(columns, data);
	},

	/* ----------- Report Complements -----------*/

	getReportSummary(title, summaryLeftList, rightList, getData = false) {
		if (getData) {
			let startArr = true;
			let auxStr = "";
			const lSummaryCols = summaryLeftList.reduce((prev, obj) => {
				if (startArr) {
					auxStr = "";
					startArr = false;
				} else {
					auxStr += " ";
				}
				const auxPrev = { ...prev };
				auxPrev[auxStr] = obj.key;
				return auxPrev;
			}, {});
			startArr = true;
			const lSummaryVals = summaryLeftList.reduce((prev, obj) => {
				if (startArr) {
					auxStr = "";
					startArr = false;
				} else {
					auxStr += " ";
				}
				const auxPrev = { ...prev };
				auxPrev[auxStr] = obj.value;
				return auxPrev;
			}, {});
			startArr = true;
			const secondStr = `${auxStr} `;
			const rSummaryCols = rightList.reduce((prev, obj) => {
				if (startArr) {
					auxStr = secondStr;
					startArr = false;
				} else {
					auxStr += " ";
				}
				const auxPrev = { ...prev };
				auxPrev[auxStr] = obj.key;
				return auxPrev;
			}, {});
			startArr = true;
			const rSummaryVals = rightList.reduce((prev, obj) => {
				if (startArr) {
					auxStr = secondStr;
					startArr = false;
				} else {
					auxStr += " ";
				}
				const auxPrev = { ...prev };
				auxPrev[auxStr] = obj.value;
				return auxPrev;
			}, {});
			const combinedCol = { ...lSummaryCols, ...rSummaryCols };
			const combinedData = { ...lSummaryVals, ...rSummaryVals };
			return [combinedCol, combinedData];
		}
		return (
			<Summary
				title={title}
				leftList={summaryLeftList}
				rightList={rightList}
			/>
		);
	},

	getGenericData(columns, data) {
		let startArr = true;
		let auxStr = "";
		const auxColumns = {};
		const cols = columns.reduce((prev, obj) => {
			if (startArr) {
				auxStr = "";
				startArr = false;
			} else {
				auxStr += " ";
			}
			const auxPrev = { ...prev };
			auxPrev[auxStr] = obj.name;
			auxColumns[`${obj.property}`] = obj.name;
			return auxPrev;
		}, {});

		const reversedCols = Object.fromEntries(
			Object.entries(cols).map(([key, value]) => [value, key]),
		);
		const rows = data.map(item => {
			const newItem = {};
			Object.keys(item).forEach(property => {
				newItem[`${reversedCols[auxColumns[`${property}`]]}`] = item[`${property}`];
			});
			return newItem;
		});
		return [cols, ...rows];
	},

	getGenericPaymentsData(columns, data) {
		let startArr = true;
		let auxStr = "";
		const auxColumns = {};
		const cols = columns.reduce((prev, obj) => {
			if (startArr) {
				auxStr = "";
				startArr = false;
			} else {
				auxStr += " ";
			}
			const auxPrev = { ...prev };
			auxPrev[auxStr] = obj.header.label;
			auxColumns[`${obj.property}`] = obj.header.label;
			return auxPrev;
		}, {});
		const reversedCols = Object.fromEntries(
			Object.entries(cols).map(([key, value]) => [value, key]),
		);
		const rows = data.map(item => {
			const newItem = {};
			Object.keys(item).forEach(property => {
				newItem[`${reversedCols[auxColumns[`${property}`]]}`] = item[`${property}`];
			});
			return newItem;
		});
		return [cols, ...rows];
	},

	getReportOverviewTable(columns, data, getData = false) {
		if (getData) {
			return this.getGenericData(columns, data);
		}
		return this.getGenericTable(columns, data);
	},

	getClientsOverviewTable(rawData, columns, getData = false) {
		const { lang } = global;
		const baseColumns = [
			{
				property: "client",
				name: "",
			},
			{
				property: "agency",
				name: lang.t("Agency"),
			},
			{
				property: "total_projects_count",
				name: lang.t("Total Project Count"),
			},
			{
				property: "job_count",
				name: lang.t("Total Jobs"),
			},
			{
				property: "total_hours_scheduled",
				name: lang.t("Total Hours Scheduled"),
			},
			{
				property: "total_hours_worked",
				name: lang.t("Total Hours Worked"),
			},
			{
				property: "locations_count",
				name: lang.t("Locations"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
			{
				property: "officers_worked_count",
				name: `# ${lang.t("Officers Worked")}`,
			},
		];

		const data = rawData
			? rawData.map(object => ({
					client: object.Client,
					total_projects_count: object.TotalProjectCount,
					job_count: object.TotalJobCount,
					total_hours_scheduled: object.HoursScheduled,
					total_hours_worked: object.HoursWorked,
					locations_count: object.TotalJobLocations,
					officers_assigned_count: object.TotalOfficersAssigned,
					officers_worked_count: object.TotalOfficersWorked,
					status: object.ProjectStatus,
					agency: object.AgencyName,
				}))
			: [];

		if (getData) {
			return this.getGenericData(columns || baseColumns, data);
		}
		return this.getGenericTable(columns || baseColumns, data, "Clients");
	},

	getProjectsOverviewTable(rawData, columns, getData = false) {
		const { lang } = global;
		const baseColumns = [
			{
				property: "project",
				name: "",
			},
			{
				property: "client",
				name: lang.t("Client"),
			},
			{
				property: "client_supervisor",
				name: lang.t("Client Supervisor"),
			},
			{
				property: "job_count",
				name: lang.t("Total Jobs"),
			},
			{
				property: "total_hours_scheduled",
				name: lang.t("Total Hours Scheduled"),
			},
			{
				property: "total_hours_worked",
				name: lang.t("Total Hours Worked"),
			},
			{
				property: "locations_count",
				name: lang.t("Locations"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
			{
				property: "officers_worked_count",
				name: `# ${lang.t("Officers Worked")}`,
			},
			{
				property: "status",
				name: lang.t("Status"),
			},
		];

		const data = rawData
			? rawData.map(object => ({
					project: object.Project,
					client: object.Client,
					client_supervisor: object.SupervisorName,
					job_count: object.TotalJobCount,
					total_hours_scheduled: object.HoursScheduled,
					total_hours_worked: object.HoursWorked,
					locations_count: object.TotalJobLocations,
					officers_assigned_count: object.TotalOfficersAssigned,
					officers_worked_count: object.TotalOfficersWorked,
					status: object.ProjectStatus,
				}))
			: [];

		if (getData) {
			return this.getGenericData(columns || baseColumns, data);
		}
		return this.getGenericTable(columns || baseColumns, data, "Projects");
	},

	getAgencyOverviewTable(rawData, columns, getData = false) {
		const { lang } = global;
		const baseColumns = [
			{
				property: "agency_name",
				name: lang.t("Agency"),
			},
			{
				property: "client_count",
				name: lang.t("Clients"),
			},
			{
				property: "job_count",
				name: lang.t("Jobs"),
			},
			{
				property: "location_count",
				name: lang.t("Locations"),
			},
			{
				property: "total_hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "total_hours_worked",
				name: lang.t("Total Hours Worked"),
			},
			{
				property: "officers_assigned_count",
				name: lang.t("Officers Assigned"),
			},
			{
				property: "officers_worked_count",
				name: lang.t("Officers Worked"),
			},
		];

		const data = rawData
			? rawData.map(object => ({
					agency_name: object.AgencyName,
					client_count: object.TotalClientCount,
					job_count: object.TotalJobCount,
					location_count: object.TotalJobLocations,
					total_hours_scheduled: object.HoursScheduled,
					total_hours_worked: object.HoursWorked,
					officers_assigned_count: object.TotalOfficersAssigned,
					officers_worked_count: object.TotalOfficersWorked,
				}))
			: [];

		if (getData) {
			return this.getGenericData(columns || baseColumns, data);
		}
		return this.getGenericTable(columns || baseColumns, data, "Agencies");
	},

	getJobsOverviewTable(rawData, columns, timeZoneId, user, getData = false) {
		const { lang } = global;
		const baseColumns = [
			{
				property: "job_id",
				name: lang.t("Job ID"),
				urlBase: "/jobs/%value%",
			},
			{
				property: "date",
				name: lang.t("Date"),
			},
			{
				property: "start_time",
				name: lang.t("Start Time"),
			},
			{
				property: "agency",
				name: lang.t("Agency"),
			},
			{
				property: "client",
				name: lang.t("Client"),
			},
			{
				property: "project_title",
				name: lang.t("Project Name"),
			},
			{
				property: "job_title",
				name: lang.t("Job Name"),
			},
			{
				property: "job_tags",
				name: lang.t("Tags"),
			},
			{
				property: "position",
				name: lang.t("Position"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "rank",
				name: "Officer Rank",
			},
			{
				property: "officer",
				name: lang.t("Officer"),
			},
			{
				property: "email",
				name: lang.t("EMail"),
			},
			{
				property: "mobile",
				name: lang.t("Mobile"),
			},
			{
				property: "job_zone",
				name: lang.t("Zone"),
			},
			{
				property: "rate",
				name: lang.t("Rate"),
			},
			{
				property: "clock_in",
				name: lang.t("Clock In"),
			},
			{
				property: "clock_out",
				name: lang.t("Clock Out"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
			{
				property: "alerts",
				name: lang.t("Alerts"),
				title: "%value%",
			},
		];

		const data = rawData
			? rawData.map(object => ({
					job_id: object.JobEventId,
					date: utils.formatDate(`${object.StartDateTime}Z`, "en-US", timeZoneId),
					start_time: utils.formatTime(
						`${object.StartDateTime}Z`,
						user.UserPreferences !== "useMilitaryTime",
						timeZoneId,
					),
					project_title: object.Project,
					job_title: object.JobEventName,
					position: object.JobTitle,
					job_location: object.JobLocation,
					job_zone: object.JobZoneName,
					job_tags: object.JobTags?.replaceAll(",", ", "),
					rank: object.OfficerRank,
					officer: object.OfficerName,
					clock_in: object.ClockIn
						? utils.formatTime(
								`${object.ClockIn}Z`,
								user.UserPreferences !== "useMilitaryTime",
								timeZoneId,
							)
						: "N/A",
					clock_out: object.ClockOut
						? utils.formatTime(
								`${object.ClockOut}Z`,
								user.UserPreferences !== "useMilitaryTime",
								timeZoneId,
							)
						: "N/A",
					vehicle: object.Vehicle,
					est_officer_pay: object.EstimatedOfficerPayDecimal,
					hours_scheduled: object.HoursScheduled,
					hours_worked: object.HoursWorked,
					alerts: object.Alerts,
					rate: object.Rate,
					email: object.OfficerEmail,
					mobile: object.OfficerMobile,
					agency: object.AgencyName,
					client: object.Client,
				}))
			: [];

		if (getData) {
			return this.getGenericData(columns || baseColumns, data);
		}
		return this.getGenericTable(columns || baseColumns, data, "Jobs");
	},

	getLocationsOverviewTable(rawData, columns, getData = false) {
		const { lang } = global;
		const baseColumns = [
			{
				property: "agency",
				name: lang.t("Agency"),
			},
			{
				property: "client",
				name: lang.t("Client"),
			},
			{
				property: "project",
				name: lang.t("Project"),
			},
			{
				property: "job_location",
				name: lang.t("Location"),
			},
			{
				property: "location_address",
				name: lang.t("Address"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
			{
				property: "zone",
				name: lang.t("Zone"),
			},
		];

		const data = rawData
			? rawData.map(object => ({
					client: object.Client,
					agency: object.AgencyName,
					project: object.Project,
					job_location: object.JobLocation,
					location_address: object.JobLocationAddress,
					jobs_scheduled: object.JobsScheduled,
					jobs_worked: object.JobsWorked,
					hours_scheduled: object.HoursScheduled,
					hours_worked: object.HoursWorked,
					zone: object.JobZoneName,
				}))
			: [];

		if (getData) {
			return this.getGenericData(columns || baseColumns, data);
		}
		return this.getGenericTable(columns || baseColumns, data, "Locations");
	},

	getOfficersOverviewTable(rawData, columns, getData = false) {
		const { lang } = global;
		const baseColumns = [
			{
				property: "officer",
				name: lang.t("Officer Name"),
			},
			{
				property: "email",
				name: lang.t("EMail"),
			},
			{
				property: "mobile",
				name: lang.t("Mobile"),
			},
			{
				property: "jobs_scheduled",
				name: lang.t("Jobs Scheduled"),
			},
			{
				property: "jobs_worked",
				name: lang.t("Jobs Worked"),
			},
			{
				property: "hours_scheduled",
				name: lang.t("Scheduled Hours"),
			},
			{
				property: "hours_worked",
				name: lang.t("Worked Hours"),
			},
		];

		const data = rawData
			? rawData.map(object => ({
					officer: object.OfficerName,
					jobs_scheduled: object.JobsScheduled,
					jobs_worked: object.JobsWorked,
					hours_scheduled: object.HoursScheduled,
					hours_worked: object.HoursWorked,
					email: object.OfficerEmail,
					mobile: object.OfficerMobile,
				}))
			: [];

		if (getData) {
			return this.getGenericData(columns || baseColumns, data);
		}
		return this.getGenericTable(columns || baseColumns, data, "Officers");
	},

	renderJobAlertsLegend() {
		return (
			<div className="text-right padding-right-10">
				<div className="color-gray-dove">Alerts: </div>
				{Object.entries(JOBS_ALERTS_LEGEND).map(([key, item]) => (
					<Fragment key={`job_alert_legend_item_${key}`}>
						<span className="font-black color-gray-dove">{key} =</span>
						&nbsp;
						<span className="color-gray-dove">{`${item}${key !== "O" ? ", " : ""}`}</span>
					</Fragment>
				))}
			</div>
		);
	},

	getGenericTable(columns, data, title) {
		return (
			<Table
				title={title}
				columns={columns}
				data={data}
			/>
		);
	},
};
